import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
    IconButton,
    CardContent,
    Box,
    Card,
    Grid,
    CardMedia,
    CardActions,
} from "@material-ui/core";
import {
    Add,
    Edit,
    Delete,
} from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getForSaleWigsService } from "./for-sale-wigs-list-service";
import { db } from "../../../../../firebase";
import ForSaleWigsListLoading from "./for-sale-wigs-list-loading";
import ForSaleWigsListEmpty from "./for-sale-wigs-list-empty";
import logo from '../../../../../assets/logo.png'
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
      background: "#111111",
      height: "100%",
      color: "#fbbbd3",
      fontSize: 14,
    },
    button: {
      background: "#111111",
      color: "#fbbbd3",
      justifyContent: "right"
    },
    text: {
      color: "#111111",
    },
    title: {
      color:"#111111",
      marginBottom: 20,
    }
}));

const ForSaleWigsList = () => {
    const classes = useStyles();
    const forSaleWigsCollection = useSelector((state) => state.forSaleWigsListSlice.rows);
    const isLoading = useSelector((state) => state.forSaleWigsListSlice.isLoading);
    const dispatch = useDispatch();

    // get data
    useEffect(() => {
        const fetchData = async () => {
            try {
                await getForSaleWigsService(dispatch, db, "items");
            } catch(e) {
                console.error("ForSaleWigsList fetchData error: ", e);
            }
        };
        fetchData();
    }, []);

    // return loading state if isLoading is true
    if (isLoading) {
        return <ForSaleWigsListLoading/>
    }

    // return empty state if isLoading is false and forSaleWigsCollection has no collection
    if (!isLoading && forSaleWigsCollection.length === 0) {
        return <ForSaleWigsListEmpty/>
    }

    return (
        <>
            <Typography className={classes.title} variant="h4">For Sale Wigs</Typography>
            <Grid container spacing={1}>
                {forSaleWigsCollection.map((row) => (
                    <Grid item xs={6} sm={4} md={3} lg={2}>
                        <Link
                            // to={`/app/for-sale/wigs/details/${row.id}`}
                            style={{ textDecoration: 'none' }}
                        >
                            <Card variant="outlined">
                                <CardMedia
                                    component="img"
                                    height="194"
                                    image={row.item_thumbnail ? row.item_thumbnail : logo}
                                    alt="PeriCoCo"
                                />
                                <CardContent>
                                    <Typography variant="h5" component="div" className={classes.text} align="left">
                                        {row.name}
                                    </Typography>
                                    <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                                        {`Price: PHP ${row.unit_price}`}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Typography sx={{ mb: 1.5 }} variant="overline" className={classes.text}>
                                        {row.status}
                                    </Typography>
                                </CardActions>
                            </Card>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </>
        
    )
};

export default ForSaleWigsList;